// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"app_outerContainer__3opJM","container":"app_container__2ebdZ","sidebar":"app_sidebar__2ESh-","content":"app_content__2hbO3"};